import { useEffect, useState } from "react";
import ConfigService from "services/UtilsService/ConfigService";
import { initializeAppInsights } from "../AppInsights";

export const useConfig = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = async () => {
    try {
      const response = await ConfigService.getConfig();

      if (response?.data) {
        const { appInsightsInstrumentationKey, postHogKey } = response.data;

        localStorage.setItem("appInsightsInstrumentationKey", appInsightsInstrumentationKey);
        localStorage.setItem("postHogKey", postHogKey);
        initializeAppInsights();
      }
    } catch (error) {
      console.error("Failed to load configuration:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return [isLoading] as const;
};
